import React from 'react';

import { FieldVolumeType } from 'reactComponents/Forms/FieldVolumeType';

export const FieldDiskType = ({
    prices,
    volumeTypes,
    onDropdownChange,
    ...otherProps
}) => {
    return (
        <FieldVolumeType
            {...{
                ...otherProps,
                onChange: onDropdownChange,
                volumeTypes,
                prices,
            }}
        />
    );
};
